import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { IncassoAdapter } from '../components/fascicolo/incassi-edit/incasso-adapter';
import { Controparte } from '../models/controparte';
import { SezioneContropartiResponse } from '../models/dto/sezione-controparti-response';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';
import { Incasso } from '../models/incasso';
import { SezioneControparti } from '../models/sezioni/sezione-controparti';
import { ModalitaPagamento } from '../models/tipologiche/modalita-pagamento';
import { TipoPagamento } from '../models/tipologiche/tipo-pagamento';
import { NumericOperationManager } from '../utils/numeric-operation-manager';
import { BaseForm } from './base-Form';

@Component({
    selector: 'div [incasso-form]',
  templateUrl: 'incasso-form.html'
})

export abstract class IncassoForm extends BaseForm {

  request: Incasso;
  fascicolo: FascicoloFull;
  incassoForm: FormGroup;
  tipiIncassoOptions: TipoPagamento[] = [];
  modalitaIncassoOptions: ModalitaPagamento[] = [];
  soggettiPagatoriOptions: Controparte[] = [];
  msgNoBeneficiari: string;

  abstract getIncasso(): Incasso;
  abstract getRequest(request: Incasso);
  abstract getUrlReadSezioneControparti(): string;

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

 initRequest() {
    this.request = new IncassoAdapter(this.getIncasso()).incasso;
  }

  createForm() {
      this.initRequest();
      this.incassoForm = this.campiForm.group({
      id: [this.request.id],
      dataIncasso: [this.request.dataIncasso, Validators.required],
      causale: [this.request.causale, Validators.required],
      soggettoPagatore: [this.request.soggettoPagatore, Validators.required],
      refAreaCompetente: [this.request.areaCompetente],
      importo: [this.request.importo],
      interessi: [this.request.interessi],
      spese: [this.request.spese],
      compensoAvvocati: [this.request.compensoAvvocati],
      tipoIncasso: [this.request.tipoIncasso],
      modalitaIncasso: [this.request.modalitaIncasso],
      note: [this.request.note],
      documenti: [this.request.documenti],
    });
  }

  populateSelect() {
    if (this.tipiIncassoOptions.length === 0) {
     this.helpers.getTipiPagamento().subscribe(response => this.tipiIncassoOptions = response);
    }
    if (this.modalitaIncassoOptions.length === 0) {
     this.helpers.getModalitaPagamento().subscribe(response => this.modalitaIncassoOptions = response);
    }
  }

  update() {
    this.getControparte(this.request.soggettoPagatore);
    this.getRequest(this.request);
  }

  readSezioneControparti(idSezioneControparti: string) {
    this.operationService.readSezione(this.getUrlReadSezioneControparti(), idSezioneControparti)
      .subscribe(response => this.readSezioneContropartiResponse((<SezioneContropartiResponse>response).sezione));
  }

  readSezioneContropartiResponse(sezioneControparti: SezioneControparti) {
    this.soggettiPagatoriOptions = sezioneControparti.controparti;
    this.soggettiPagatoriOptions = this.soggettiPagatoriOptions.filter(controparte => { return controparte.ritirato === false; });
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare';
  }

  getSoggettoLabel(soggettoPagatore: Controparte): string {
    let result = '';
    if (soggettoPagatore && soggettoPagatore.parte && soggettoPagatore.parte.tipoPersona) {
      if (soggettoPagatore.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = soggettoPagatore.parte.cognome + ' ' + soggettoPagatore.parte.nome;
      }
      if (soggettoPagatore.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = soggettoPagatore.parte.ragioneSociale;
      }
    }
    return result;
  }

  getControparte(obj: any) {
    if (obj && obj.id) {
      this.request.soggettoPagatore =  this.soggettiPagatoriOptions.filter(controparte => { return controparte.id === obj.id; })[0];
    }
  }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  stringToNumber(a: string): number {
    return Number(a);
  }

}
